import { isServer } from '@/utils/url';
import { getSafeQueryValue } from '@/utils/tool';

export const handleCmsFetch = (params: any) => {
  if (isServer) return params;
  let sp = new URLSearchParams(location.search);
  if (sp.get('mode') === 'preview') {
    params.platform = 'h5';
  }
  return params;
};

/**
 * 处理 pin_top 参数，支持 SSR 和客户端
 * @param params 请求参数
 * @param ctx SSR 上下文（可选）
 */
export const handlePinTop = (params: any, ctx?: any) => {
  if (ctx?.query?.pin_top) {
    // SSR 场景：从 ctx.query 获取
    params.pin_top = getSafeQueryValue(ctx.query.pin_top);
  } else if (typeof window !== 'undefined') {
    // 客户端场景：从 window.location 获取
    const urlParams = new URLSearchParams(window.location.search);
    const pinTop = urlParams.get('pin_top');
    if (pinTop) {
      params.pin_top = pinTop;
    }
  }
  return params;
};

export const getStaticResData = (staticRes: Record<string, any>) => {
  if (!staticRes) {
    return {
      result: false,
      object: {}
    };
  }

  if (!Object.hasOwn(staticRes, 'result')) {
    return {
      result: true,
      object: staticRes
    };
  }
  return staticRes;
};
